import React from "react";

const UserProfile = ({ firstName, lastName, hideSubtitle = false }) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center gap-5 lg:gap-9 mb-[80px]">
      <div className="relative w-[150px] h-[150px] rounded-full">
        <img
          src="/images/AVATAR.png"
          alt="Mila"
          className="absolute inset-2 w-[134px] h-[134px] rounded-full overflow-hidden object-cover"
        />
        <img
          src="/images/animation.svg"
          alt="Circle"
          className="absolute inset-0 overflow-hidden object-cover animate-circle-spin"
        />
      </div>
      <div className="flex flex-col gap-5 text-dark-blue-200">
        <h2 className="text-[40px] font-medium  font-urbanist">
          Hey {firstName} {lastName}
        </h2>
        {!hideSubtitle && (
          <p className="mb-5 max-w-[350px]">
            Ask me a question about your fleet management or choose a suggested
            one
          </p>
        )}
      </div>
    </div>
  );
};

export default UserProfile;
